module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/1-on-95413dd373ae4e4b5161cbfdb4b769ec.png";